import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

import {
  DialogGreyOutlinedButton,
  ElevatedGreenButton,
} from "../Button/CustomButton";
import FormOne from "../MangeSuccessfulBusiness/FormOne";

import {
  customButtonStyle,
  StyledStepper,
  StyledStepperBox,
} from "../MangeSuccessfulBusiness/dialogStyles/DialogStyles";
import { useDispatch, useSelector } from "react-redux";
import { fetchCorpsMember, RestoreCorpsMember } from "../../Actions/Users";
import { isSignedIn } from "../../Hooks/auth";
import {
  addBusinessManagement,
  fetchBusinessManagement,
  fetchTotalBusinessManagement,
  restoreBusinessInitial,
} from "../../Actions";
import validators from "../../Utils/Validators";
import { errors } from "../../Utils/ErrorMessages/businessmgt";
import FormTwo from "../MangeSuccessfulBusiness/FormTwo";
const getCMState = (state) => state.usersReducer;
const getBusinessState = (state) => state.businessReducer;

const steps = ["Select Ex Corps Member", "Add Business Details"];

export default function CMForm({
  isFoundCM,
  handleIsFoundCM,
  handleResetFoundCM,
  handleCloseDialog,
  isClosedDialog,
  resetState,
  showNoError,
  showError,
  isError,
  resetFoundCM
}) {
  const { corpsmemberDetails, isLoading } = useSelector(getCMState);
  const { businessCreated } = useSelector(getBusinessState);

  const [activeStep, setActiveStep] = useState(0);
  const [checked, setChecked] = useState(true);
  const user = JSON.parse(isSignedIn);
  const dispatch = useDispatch();
  const initialFormValues = {
    stateCode: "",
    stateId: user?.stateID,
    userId: user?.id,
    hash: "",
    businessFormValues: {
      stateCode: "",
      cmName: "",
      businessName: "",
      email: "",
      phoneNumber: "",
      sourceOfFund: "0",
      staffStrength: 0,
      streetAddress: "",
      stateId: 0,
      isActive: true,
      lgaId:0,
    },
  };

  const initialFormState = {
    businessNameError: false,
    businessNameErrorMsg: "",
    emailAddressError: false,
    emailAddressErrorMsg: "",
    phoneNumberError: false,
    phoneNumberErrorMsg: "",
    phoneNumberConfirmError: false,
    phoneNumberConfirmErrorMsg: "",
    staffStrengthError: false,
    staffStrengthErrorMsg: "",
    stateOfResidenceError: false,
    stateOfResidenceErrorMsg: "",
    sourceOfFundsError: false,
    sourceOfFundsErrorMsg: "",
    streetAddressError: false,
    streetAddressErrorMsg: "",
    inputError:false,
    inputErrorMsg:"",
     lgaError: false,
    lgaErrorMsg: "Select a state before choosing LGA",
  };

  const [formValues, setFormValues] = useState({ ...initialFormValues });
  const [loadingButton, setLoadingButton] = useState(false);
  const [showCM, setShowCM] = useState(isFoundCM);
  const [stateValue, setStateValue] = React.useState("");
  const [values, setValues] = useState({});
  const [lgaValues, setLgaValues] = useState({});
  const [formStates, setFormStates] = useState(initialFormState);
  

  const stateCodeHandler = (e) => {
    let stateCodeValue = e.target.value;
    setFormValues({ ...formValues, stateCode: stateCodeValue });
    setFormStates({
      ...formStates,
      inputError: false,
      inputErrorMsg:  "",
    });
  };

  const SetIsRequiredError = (
    value,
    stateError,
    stateErrorMsg,
    len = 1,
    errorMsg = "Field is required",
    max = 0,
    select = false
  ) => {
    if (!validators.isRequired(value, len, max, select)) {
      setFormStates((prevState) => [
        {
          ...prevState,
          [stateError]: true,
          [stateErrorMsg]: errorMsg,
        },
      ]);
      return false;
    }

    setFormStates({ ...formStates, [stateError]: false, [stateErrorMsg]: "" });
    return true;
  };

  const findCMHandler = () => {
    debugger
    const { businessFormValues, ...submittedFormValues } = formValues;
    if(formValues.stateCode === ""){
      resetFoundCM()
      const isValid = SetIsRequiredError(
        formValues.stateCode,
        "inputError",
        "inputErrorMsg",
        11, // Minimum required length of input value
        "Please enter a valid input",
        12 // Maximum allowed length of input value
      );
      setFormStates({
        ...formStates,
        inputError: !isValid,
        inputErrorMsg: isValid ? "" : "*State code is required",
      });
      showError();
      setShowCM(false)
    }else{
    setLoadingButton(true);
    dispatch(fetchCorpsMember(submittedFormValues));
    setShowCM(true);
    }
 
  };

  useEffect(()=>{
      if(resetState === true){
        setFormStates({...initialFormState});
        setValues({
          label: "",
          value: 0,
        });
        setLgaValues({
          label:"",
          value:0
        })
      }
  },[resetState])

  useEffect(() => { 
    if (!isLoading && Object.keys(corpsmemberDetails).length > 0) {
      setLoadingButton(false);
     showNoError();
      setFormValues((prevValues) => ({
        ...prevValues,
        businessFormValues: {
          ...prevValues.businessFormValues,
          stateCode: corpsmemberDetails?.data?.stateCode,
        },
      }));
      return () => {
        dispatch(RestoreCorpsMember());
      };
    }
  }, [isLoading, corpsmemberDetails, dispatch]);

  useEffect(() => {
    if (showCM && !isLoading) {
      setShowCM(false);
    }
  }, [showCM, isLoading]);

  const updateValue = (value) => {
    debugger
    setStateValue(value);
    setValues({
      ...values,
      label: value.label,
      value: value.value,
    });
    if (value.value !== 0) {
      setFormStates({
        ...formStates,
        stateOfResidenceError: false,
        stateOfResidenceErrorMsg: "",
      });
    }
  };

  const updateLgaValue = (value) => {
    setLgaValues({
      ...values,
      label: value.label,
      value: value.value,
    });
    if (value.value !== 0) {
      setFormStates({
        ...formStates,
        lgaError: false,
        lgaErrorMsg: "",
      });
    }
  };
  const stateHandler = (event, val) => {
    if (event) {
      setLgaValues({})
      setStateValue(val.value);
      setFormValues((prevValues) => ({
        ...prevValues,
        businessFormValues: {
          ...prevValues.businessFormValues,
          stateId: val.value,
        },
      }));
      if (val.value !== 0) {
        setFormStates({
          ...formStates,
          stateOfResidenceError: false,
          stateOfResidenceErrorMsg: "",
        });
      }
    }
  };

  const lgaHandler = (event, val) => {
    debugger
    if (event) {
      setFormValues((prevValues) => ({
        ...prevValues,
        businessFormValues: {
          ...prevValues.businessFormValues,
          lgaId: val.value,
        },
      }));
      if (val.value !== 0) {
        setFormStates({
          ...formStates,
          lgaError: false,
          lgaErrorMsg: "",
        });
      }
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setFormValues((prevValues) => ({
      ...prevValues,
      businessFormValues: {
        ...prevValues.businessFormValues,
        cmName: corpsmemberDetails?.data?.cmName,
      },
    }));
  };

  const ToBusinessPageHandler = () => {
    handleNext();
    handleIsFoundCM();
  };

  const BackToFirstPageHandler = () => {
    handleBack();
    handleResetFoundCM();
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    dispatch(restoreBusinessInitial());
    handleResetFoundCM();
    setFormValues({
      ...initialFormValues,
    });
    setValues({
      label: "",
      value: 0,
    });
    setActiveStep(0);
    setFormStates({
      ...initialFormState
    })
  };

  const handleClose = () => {
    handleCloseDialog();
    handleReset();
  };

  useEffect(() => {
    if (isClosedDialog) {
      setActiveStep(0);
      setFormValues({ ...initialFormValues });
      setShowCM(isFoundCM);
      setLoadingButton(false)
    }
  }, [isClosedDialog]);

  const handleBlurEmail = (event) => {
    let newValue = event.target.value;
    newValue = event.target.value.trim();
    if (!validators.isValidEmail(newValue)) {
      setFormStates({
        ...formStates,
        emailAddressError: true,
        emailAddressErrorMsg:
          "Please enter a valid email or clear your selection",
      });
      return false;
    }
    setFormStates({
      ...formStates,
      emailAddressError: false,
      emailAddressErrorMsg: "",
    });
  };

  const handleBlurPhoneNumber = (event) => {
    let newValue = event.target.value;
    newValue = event.target.value.trim();
    if (!validators.isPhoneLength(newValue)) {
      setFormStates({
        ...formStates,
        phoneNumberError: true,
        phoneNumberErrorMsg:
          "Please enter a valid phone number or clear your selection",
      });
      return false;
    }else if (newValue === ""){
      setFormStates({
        ...formStates,
        phoneNumberError: true,
        phoneNumberErrorMsg:
          "Please fill in phone number",
      });
    }
    setFormStates({
      ...formStates,
      phoneNumberError: false,
      phoneNumberErrorMsg: "",
    });
  };

  const handleBusinessForm = (event) => {
    event.preventDefault();
    const { name, value, checked } = event.target;
    let newValue = value;
    if (name === "isActive") {
      newValue = checked;
    }
    setFormValues((prevValues) => ({
      ...prevValues,
      businessFormValues: {
        ...prevValues.businessFormValues,
        [name]: newValue,
      },
    }));
    switch (name) {
      case "businessName":
        if (newValue === "") {
          setFormStates({
            ...formStates,
            businessNameError: true,
            businessNameErrorMsg: errors.businessName,
          });
        } else {
          setFormStates({
            ...formStates,
            businessNameError: false,
            businessNameErrorMsg: "",
          });
        }
        break;
      case "email":
        if (newValue === "") {
          setFormStates({
            ...formStates,
            emailAddressError: true,
            emailAddressErrorMsg: errors.emailAddress,
          });
        } else {
          /*   newValue = event.target.value.trim();
          if (!validators.isValidEmail(newValue)) {
            setFormStates({
              ...formStates,
              emailAddressError: true,
              emailAddressErrorMsg:
                "Please enter a valid email or clear your selection",
            });
            return false;
          } */
          setFormStates({
            ...formStates,
            emailAddressError: false,
            emailAddressErrorMsg: "",
          });
        }
        break;
      case "phoneNumber":
        if (newValue === "") {
          setFormStates({
            ...formStates,
            phoneNumberError: true,
            phoneNumberErrorMsg: errors.phoneNumber,
          });
        } else {
          setFormStates({
            ...formStates,
            phoneNumberError: false,
            phoneNumberErrorMsg: "",
          });
        }
        break;
      case "staffStrength":
        if (newValue === "") {
          setFormStates({
            ...formStates,
            staffStrengthError: true,
            staffStrengthErrorMsg: errors.staffStrength,
          });
        } else {
          setFormStates({
            ...formStates,
            staffStrengthError: false,
            staffStrengthErrorMsg: "",
          });
        }
        break;
      case "streetAddress":
        if (newValue === "") {
          setFormStates({
            ...formStates,
            streetAddressError: true,
            streetAddressErrorMsg: errors.location,
          });
        } else {
          setFormStates({
            ...formStates,
            streetAddressError: false,
            streetAddressErrorMsg: "",
          });
        }
        break;
      case "state":
        if (newValue === 0) {
          setFormStates({
            ...formStates,
            stateOfResidenceError: true,
            stateOfResidenceErrorMsg: errors.location,
          });
        } else {
          setFormStates({
            ...formStates,
            stateOfResidenceError: false,
            stateOfResidenceErrorMsg: "",
          });
        }
        break;
      default:
        break;
    }
  };

  const handleSubmit = (e) => {  
    debugger
    e.preventDefault();
    const { businessFormValues } = formValues;
    if(formStates.emailAddressError === true){
      setFormStates({
        ...formStates,
        emailAddressError: true,
        emailAddressErrorMsg:
          "Please enter a valid email or clear your selection",
      });
    }else if (formStates.phoneNumberError === true){
      setFormStates({
        ...formStates,
        phoneNumberError: true,
        phoneNumberErrorMsg:
          "Please enter a valid phone number or clear your selection",
      });
    }else{
      if (
        Object.values(businessFormValues).every(
          (value) =>
            value !== "" &&
            (value !== 0 || value === "0" || value === "1" || value === 1)
        )
      ) {
        setLoadingButton(true);
        console.log(formValues.businessFormValues)
        dispatch(addBusinessManagement(formValues.businessFormValues));
      } else {   
        if (
          businessFormValues.businessName === "" ||
          businessFormValues.email === "" ||
          businessFormValues.phoneNumber === "" ||
          businessFormValues.staffStrength === 0 ||
          businessFormValues.streetAddress === "" ||
          businessFormValues.stateId === 0 ||
          businessFormValues.lgaId === 0
         
        ) {
          setFormStates({
            ...formStates,
            businessNameError: businessFormValues.businessName === "",
            businessNameErrorMsg:
              businessFormValues.businessName === "" ? errors.businessName : "",
            emailAddressError: businessFormValues.email === "",
            emailAddressErrorMsg:
              businessFormValues.email === "" ? errors.emailAddress : "",
            phoneNumberError: businessFormValues.phoneNumber === "",
            phoneNumberErrorMsg:
              businessFormValues.phoneNumber === "" ? errors.phoneNumber : "",
            staffStrengthError: businessFormValues.staffStrength === 0,
            staffStrengthErrorMsg:
              businessFormValues.staffStrength === 0 ? errors.staffStrength : "",
            streetAddressError: businessFormValues.streetAddress === "",
            streetAddressErrorMsg:
              businessFormValues.streetAddress === "" ? errors.location : "",
            stateOfResidenceError: businessFormValues.stateId === 0,
            stateOfResidenceErrorMsg:
              businessFormValues.stateId === 0 ? errors.location : "",
              lgaError: businessFormValues.lgaId === 0,
              lgaErrorMsg:
                businessFormValues.lgaId === 0 ? errors.location : "",
          });
        }
      }
    }
  };

  useEffect(() => {
    if (businessCreated) {
      setLoadingButton(false);
      handleNext();
      handleResetFoundCM();
      // handleReset();
      dispatch(fetchBusinessManagement());
      dispatch(fetchTotalBusinessManagement());
    }
  }, [businessCreated, dispatch]);

  return (
    <StyledStepperBox>
      
          <FormTwo
            steps={steps}
            activeStep={activeStep}
            // handleBack={handleBack}
            handleSubmit={handleSubmit}
            checked={checked}
            // handleChange={handleChange}
            formValues={formValues}
            handleBusinessForm={handleBusinessForm}
            updateValue={updateValue}
            updateLgaValue={updateLgaValue}
            stateHandler={stateHandler}
            lgaHandler={lgaHandler}
            loadingButton={loadingButton}
            values={values}
            lgaValues={lgaValues}
            formStates={formStates}
            handleBlurEmail={handleBlurEmail}
            handleBlurPhoneNumber={handleBlurPhoneNumber}
          />
    </StyledStepperBox>
    
  );
}
